import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import useLang from "../contexts/Language/LanguageContext";
import translate from "../utils/lang/langHash";
import Carousel from "../components/carousel/Carousel";
import Footer from "../components/footer/Footer";
import Seo from "../components/seo/Seo";
import toItem from "../utils/content/toItem";

const IndexPage = () => {
  const lang = useLang();
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
      allContentfulProject(sort: { fields: publishedDate, order: DESC }) {
        edges {
          node {
            id
            title
            titleen
            slug
            isNews
            rootproject
            publishedDate
            description {
              raw
              references {
                ... on ContentfulAsset {
                  gatsbyImageData(width: 1200)
                }
              }
            }
            descriptionen {
              raw
              references {
                ... on ContentfulAsset {
                  gatsbyImageData(width: 1200)
                }
              }
            }
          }
        }
      }
    }
  `);
  const { siteUrl } = data.site.siteMetadata;
  const organization = {
    "@context": "https://schema.org",
    "@type": "NGO",
    name: "I MI Boke",
    alternateName: [
      "Inicijativa mladih s invaliditetom Boke",
      "Initiative of Youth with Disabilities of Boka",
      "IYDB",
    ],
    url: siteUrl,
    logo: siteUrl + "/logo.jpg",
    email: "info@imiboke.me",
    foundingDate: "2019-04-11",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Kotor",
      addressCountry: "ME",
    },
    sameAs: [
      "https://www.facebook.com/Initiative-of-Youth-with-Disabilities-of-Boka-I-MI-Boke-111829123575190",
      "https://www.instagram.com/i.mi.boke_iydb/",
      "https://twitter.com/imiboke_iydb",
      "https://www.youtube.com/channel/UCA6TZKW4sYQ_Hk7taR57sVA",
      "https://www.linkedin.com/company/i-mi-boke-inicijativa-mladih-s-invaliditetom-boke-initiative-of-youth-with-disabilities-of-boka",
    ],
  };
  const { edges } = data.allContentfulProject;
  const projects = edges
    .filter(({ node }) => !node.isNews && node.rootproject)
    .map(({ node }) => toItem(node, lang, "/projects"));
  const news = edges
    .filter(({ node }) => node.isNews)
    .map(({ node }) => toItem(node, lang, "/news"));
  return (
    <>
      <Seo>
        <script type="application/ld+json">
          {JSON.stringify(organization)}
        </script>
      </Seo>
      <Carousel
        kind="projects"
        title={translate("home-projects", lang)}
        headingLevel={1}
        items={projects}
      />
      <Carousel
        kind="news"
        title={translate("home-news", lang)}
        headingLevel={2}
        items={news}
      />
      <Footer />
    </>
  );
};

export default IndexPage;
